<script>
import pagination from "@/mixins/pagination";
import taskDefaultList from "@/mixins/taskDefaultList";
import BaseSubNav from "@/components/ui/BaseSubNav.vue";

export default {
  name: "MedicationDefaultList",

  mixins: [pagination, taskDefaultList],

  components: {
    BaseSubNav,
  },

  data() {
    return {
      configType: "medications",
    };
  },
};
</script>

<template lang="pug">
  section
    BaseSubNav(
      navigationType="treatment"
      :showNavigation="true"
    )
      template(#title)
        | Medicaciones
        small(v-if="pagination.total")  ({{ pagination.total }})
      template(#actions)
          el-input.search__input(prefix-icon="el-icon-search" v-on:input="debounceInput" v-model="searchInput" placeholder="Buscar" :clearable="true")
          router-link.button.button--blue(:to="{name: 'create-task', params: { taskType: 'medications' }}" v-auth="'task-default.create'")
            micon(name="add_circle_outline").button__icon
            span.button__text Nueva Medicación
    .box.box--with-subnav
      .box__content--stretch
        table
          thead
            tr
              th Nombre de la medicación
              th Descripcion
              th Acciones
          tbody
            spinner(v-if="isLoading && !tasks.length")
            tr(v-else, v-for="m in tasks", :key="m._id")
              td {{ m.name }}
              td {{ m.description }}
              td.actions
                .actions-container
                  button.button.button--action(@click="edit(m._id)")
                    micon(name="edit")
                  button.button.button--action(@click="remove(m)")
                    micon(name="delete_forever")
      pagination(
        :isLoading="isLoading"
        :limit="pagination.limit",
        :total="pagination.total",
        @pagination="setPagination"
      )
</template>
